var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "person_add_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8413",
    "data-name": "Path 8413",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8414",
    "data-name": "Path 8414",
    d: "M15,12a4,4,0,1,0-4-4A4,4,0,0,0,15,12ZM6,10V8A1,1,0,0,0,4,8v2H2a1,1,0,0,0,0,2H4v2a1,1,0,0,0,2,0V12H8a1,1,0,0,0,0-2Zm9,4c-2.67,0-8,1.34-8,4v1a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1V18C23,15.34,17.67,14,15,14Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmployee);
export default __webpack_public_path__ + "static/media/add_employee.95cb396fe486a6df1f714e1ff5d4d2fc.svg";
export { ForwardRef as ReactComponent };